import { Container } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import AccessHistoryList from '../../../Component/Application/AccessHistory/AccessHistoryList';
import { useTranslation } from 'react-i18next';

const AccessHistory = () => {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t('Historial de Acceso')} parent={t('Administración')} />
      <Container fluid>
        <AccessHistoryList />
      </Container>
    </div>
  );
};

export default AccessHistory;

